<template>
  <v-layout>
    <v-flex xs12>
      <v-data-table
        class="elevation-3"
        item-key="orderId"
        :items-per-page="ordersItemPerPage"
        :page="ordersPage"
        :headers="headers"
        :items="orders"
        :footer-props="{
          itemsPerPageOptions: [20, 50, 100, 500, -1],
        }"
        @pagination="changeFilterOrders($event, 'pagination')"
      >
        <template v-slot:[`body.prepend`]="{ isMobile }">
          <tr>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-text-field
                clearable
                height="25"
                color="secondary"
                v-model="filterNumber"
                label="Номер заказа"
              ></v-text-field>
            </td>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-layout align-center>
                <v-flex>
                  <v-menu
                    offset-y
                    transition="scale-transition"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        readonly
                        clearable
                        height="25"
                        color="secondary"
                        v-on="on"
                        label="Начало"
                        v-model="filterStartDate"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="secondary"
                      v-model="filterStartDate"
                      @change="changeFilterOrders($event, 'filterStartDate')"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex>
                  <v-icon class="mx-1">{{ icons.arrowLeftRight }}</v-icon>
                </v-flex>
                <v-flex>
                  <v-menu
                    offset-y
                    transition="scale-transition"
                    :close-on-content-click="false"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        readonly
                        clearable
                        height="25"
                        color="secondary"
                        v-on="on"
                        label="Окончание"
                        v-model="filterEndDate"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      color="secondary"
                      v-model="filterEndDate"
                      @change="changeFilterOrders($event, 'filterEndDate')"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </td>
            <td></td>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-autocomplete
                clearable
                height="25"
                color="secondary"
                v-model.trim="filterPoint"
                label="Пункт доставки"
                :items="points"
                item-text="address"
                item-value="address"
                @change="changeFilterOrders($event, 'filterPoint')"
              ></v-autocomplete>
            </td>
            <td :class="isMobile ? 'v-data-table__mobile-row' : ''">
              <v-text-field
                clearable
                color="secondary"
                height="25"
                v-model="filterUser"
                label="Пользователь"
              ></v-text-field>
            </td>
          </tr>
        </template>

        <template v-slot:[`item.created`]="{ item }">
          {{ item.created | datetime }}
        </template>

        <template v-slot:[`item.total`]="{ item }">
          {{ item.total | twoDecimalPoint }}
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn icon :to="{ name: 'order', params: { id: item.orderId } }">
            <v-icon>{{ icons.viewList }}</v-icon>
          </v-btn>
        </template>

        <template v-slot:no-data>
          <v-alert :value="true" type="warning">Записи не найдены</v-alert>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapActions } from "vuex";

import { Icon } from "@/helpers";

export default {
  props: {
    orders: Array,
  },
  computed: {
    ...mapState({
      user: (state) => state.users.user,
      points: (state) => state.points.points,
      filterOrders: (state) => state.orders.filterOrders,
    }),
    headers: function () {
      return [
        {
          text: "№",
          value: "number",
          filter: (value) => {
            if (!this.filterNumber) return true;

            return value.search(new RegExp(this.filterNumber, "i")) > -1;
          },
        },
        {
          text: "Дата заказа",
          value: "created",
          filter: (value) => {
            if (!this.filterStartDate && !this.filterEndDate) return true;

            return this.$dayjs(value).isBetween(
              this.filterStartDate ? this.filterStartDate : "2019-01-01",
              this.filterEndDate ? this.filterEndDate : this.$dayjs()
            );
          },
        },
        {
          text: "Сумма заказа",
          value: "total",
        },
        {
          text: "Пункты доставки",
          value: "pointAddress",
          filter: (value) => {
            if (!this.filterPoint) return true;

            // return(
            //   value.filter(item => {
            //     return (
            //       // item.address.search(new RegExp(this.filterPoint, "i")) > -1
            //       item.address === this.filterPoint
            //     );
            //   }).length > 0
            // );

            return value.toLowerCase() === this.filterPoint.toLowerCase();
          },
        },
        {
          text: "Пользователь",
          value: "user",
          filter: (value) => {
            if (!this.filterUser) return true;

            return value.search(new RegExp(this.filterUser, "i")) > -1;
          },
        },
        { text: "", value: "actions", sortable: false },
      ];
    },
  },
  methods: {
    ...mapActions({
      getUser: "users/GET_USER",
      getPoints: "points/GET_POINTS",
      updateFilterOrders: "orders/UPDATE_FILTER_ORDERS",
    }),
    init: function () {
      if (this.filterOrders && this.filterOrders != null) {
        this.filterStartDate = this.filterOrders.filterStartDate ?? "";
        this.filterEndDate = this.filterOrders.filterEndDate ?? "";
        this.filterPoint = this.filterOrders.filterPoint ?? "";
        this.ordersItemPerPage =
          this.filterOrders.pagination && this.filterOrders.pagination != null
            ? this.filterOrders.pagination.itemsPerPage
            : this.ordersItemPerPage;
        this.ordersPage =
          this.filterOrders.pagination && this.filterOrders.pagination != null
            ? this.filterOrders.pagination.page
            : this.ordersPage;
      }
    },
    changeFilterOrders: function (value, key) {
      this.updateFilterOrders({ [key]: value });
    },
  },
  data: () => ({
    filterNumber: "",
    filterPoint: "",
    filterUser: "",
    filterStartDate: "",
    filterEndDate: "",
    ordersItemPerPage: 20,
    ordersPage: 1,
    icons: {
      arrowLeftRight: Icon.arrowLeftRight,
      viewList: Icon.viewList,
    },
  }),
  mounted: async function () {
    await this.getUser(this.user.userId);
    await this.getPoints(this.user.userId);
    this.init();
  },
};
</script>
